export const labels = {
  TODO: 'To-Do',
};

export const routesConfig = {};
